
interface HeroProps {
  scrollToSection: (sectionId: string) => void;
}

export default function Hero({ scrollToSection }: HeroProps) {
  return (
    <section className="relative h-screen w-full overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img 
          src="https://public.readdy.ai/ai/img_res/e86f236758995858d9b1a54fbe134b0b.jpg" 
          alt="Longhorn cattle at sunset" 
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
      </div>

      {/* Content */}
      <div className="relative h-full flex items-center justify-center">
        <div className="max-w-7xl mx-auto px-6 text-center">
          <h1 className="text-7xl font-bold text-white mb-6" style={{ fontFamily: 'Playfair Display, serif' }}>
            Faith • Purpose • Stewardship
          </h1>
          <p className="text-2xl text-white/95 font-light mb-12 max-w-3xl mx-auto">
            Raising longhorns with devotion, serving communities with love
          </p>
          
          <div className="flex items-center justify-center gap-8 mt-16">
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-8 max-w-sm">
              <p className="text-white text-lg leading-relaxed">
                Guided by Christian values, we steward God's creation through responsible ranching while serving our community with compassion and purpose.
              </p>
            </div>
            <div className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-lg p-8 max-w-sm transform translate-y-[-60px]">
              <div className="text-white">
                <div className="text-5xl font-bold mb-2">50+</div>
                <p className="text-lg">Families Served Through Our Ministry</p>
              </div>
            </div>
          </div>

          <button 
            onClick={() => scrollToSection('about')}
            className="mt-12 px-8 py-4 bg-white text-[#3E2723] rounded-full font-semibold text-lg hover:bg-white/90 transition-all whitespace-nowrap"
          >
            Discover Our Story
          </button>
        </div>
      </div>
    </section>
  );
}
